import './IntegrationsModal.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import Button from 'src/component/UI/Button';
import FeatureFence from 'src/component/FeatureFence';
import { useTranslation } from 'src/i18n';

export default function IntegrationsModal (props) {
  const { t } = useTranslation();

  const handleSubmit = (integrationType) => {
    return () => {
      props.handleSubmit(integrationType);
    };
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='integration-modal-title'
    >
      <div className='modal integration-modal'>
        <h2 id='integration-modal-title'>{t('integrations.chooseIntegration')}</h2>
        <div className='integration-modal-content'>
          <Button cta onClick={handleSubmit('weather')} >{t('integrations.localWeather').split(' ')[0]}<br />{t('integrations.localWeather').split(' ')[1]}</Button>
          <Button cta onClick={handleSubmit('ambient_weather')} >{t('integrations.ambientRtdWeather').split(' ').slice(0, 2).join(' ')}<br />{t('integrations.ambientRtdWeather').split(' ').slice(2).join(' ')}</Button>
          <Button cta onClick={handleSubmit('azure_ad')} >{t('integrations.azure')}</Button>
          <FeatureFence can={['pager-duty']}>
            <Button cta onClick={handleSubmit('pager_duty')} >{t('integrations.pagerDuty')}</Button>
          </FeatureFence>
          <Button cta onClick={handleSubmit('raychem')} >nVent<br />Raychem</Button>
          <Button cta onClick={handleSubmit('tvne')} >Thermon<br />TVNE</Button>
          <Button cta onClick={handleSubmit('intellitrace')} >Chromalox<br />Intellitrace</Button>
          <Button cta onClick={handleSubmit('genesis')} >Thermon<br />Genesis</Button>
          <Button cta onClick={handleSubmit('sap')} >{t('integrations.sap')}</Button>
          <Button cta onClick={handleSubmit('oracle')} >{t('integrations.oracle')}</Button>
          <Button cta onClick={handleSubmit('maximo')} >{t('integrations.maximo')}</Button>
        </div>
        <div className='button-bar'>
          <Button onClick={props.handleClose} >{t('common.cancel')}</Button>
        </div>
      </div>

    </Modal>
  );
}

IntegrationsModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

IntegrationsModal.defaultProps = {
};
